import styled from "styled-components";
import Colors from "../../../shared/colors";

export default styled.div`
  background: ${Colors.alabaster};
  padding: 140px 0px 100px 0px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;

  .custom-select-red .custom-select__placeholder {
    color: ${Colors.valencia} !important;
  }

  .main-title {
    font-size: 30px;
    font-weight: 700px;
    color: ${Colors.aquaDeep};

    hr {
      color: ${Colors.aquaDeep};
    }
  }

  label {
    padding-right: 25px;
  }

  a {
    color: ${Colors.doveGray};
  }

  .remove-outline {
    outline: transparent;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px;
    -webkit-box-shadow: 0 0 0 30px ${Colors.alabaster} inset !important;
  }
  .second-title {
    font-size: 18px;
    font-weight: 700;
  }

  .layout {
    max-width: 1100px;
    margin: 0 auto;

    @media screen and (max-width: 1200px) {
      max-width: 800px;
    }

    @media screen and (max-width: 850px) {
      max-width: 600px;
    }
  }

  .select-marketing {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
    .marketing-to-select {
      margin-top: 10px;
      margin-right: 5px;
      height: 68px;
      min-width: 154px;
      max-width: 197px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      box-sizing: border-box;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
      border-radius: 500px;
      border: 3px solid ${Colors.gray};
      cursor: pointer;
    }
    .logo-clicked {
      border: 3px solid ${Colors.aquaDeep};
    }
  }

  input {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 15px;
    background-color: ${Colors.alabaster};
    border: 0;
    border-bottom: 1px solid ${Colors.silver};
    font-size: 18px;
    line-height: 22px;
    color: ${Colors.gray};
    padding: 0;
  }

  input.dove-gray {
    color: ${Colors.doveGray};
    margin-bottom: 0px;
    padding-bottom: 4px;
    padding-left: 2px;
    margin-top: 11px;
  }

  .input.dove-gray-only {
    color: ${Colors.doveGray};
  }

  .inputs-div {
    padding-left: 10.5px;
  }

  p {
    padding: 0 !important;
  }

  .prescriber-details-inputs {
    padding-right: 0px;
  }

  .wrapper-order {
    padding: 10px 0px;
    max-width: 1100px;

    @media screen and (max-width: 1200px) {
      max-width: 800px;
    }

    @media screen and (max-width: 850px) {
      max-width: 600px;
    }
  }

  /* TABS */

  .nav-link,
  .nav-tabs .nav-link.active {
    color: white;
    box-shadow: 8px 4px 4px rgb(0 0 0 / 25%);
    height: 48px;
    min-width: 121px;
  }

  .nav-link {
    background: #646464;
  }

  .nav-link.active {
    background: #00594c;
  }

  .nav-link.disabled {
    background: #c8c8c8;
    color: white;
  }

  .wrapper-tab {
    background: #f8f8f8;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    min-height: 188px;
    padding: 15px 37px;
  }

  .nav-tabs {
    margin-bottom: 0 !important;
  }

  .tab-content {
    position: relative;
  }

  .tab-pane {
    padding-left: 0;
    margin-bottom: 10px;
  }

  .reorder-cycle-style {
    z-index: 5;
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    text-decoration-line: underline;
    color: #ffffff;
    cursor: grab;
    pointer-events: all;
    position: absolute;
    top: 3px;
    left: 0;
    right: 0;
  }

  .remove-cycle-style {
    z-index: 5;
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    text-decoration-line: underline;
    color: #d73131;
    cursor: pointer;
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
  }

  .white-text {
    color: #ffffff;
  }

  .add-cycle-style {
    z-index: 5;
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    text-decoration-line: underline;
    color: #00a03b;
    cursor: pointer;
  }

  .remove-cycle-2 {
    position: absolute;
    left: 163px;
    top: -45px;
  }

  .add-cycle-2 {
    position: absolute;
    left: 172px;
    top: -45px;
  }

  .remove-cycle-3 {
    position: absolute;
    left: 285px;
    top: -45px;
  }

  .add-cycle-3 {
    position: absolute;
    left: 296px;
    top: -45px;
  }

  .custom-selected-brand {
    background: transparent;
    box-shadow: none;
    cursor: default;

    .select-brand {
      font-size: 14px;
      line-height: 17px;
      color: #8c8c8c;
      text-align: left;
    }
    .brand {
      font-size: 18px;
      line-height: 22px;
      color: #8c8c8c;
      text-align: left;
    }
  }

  .custom-selected-brand:hover {
    border-color: transparent;
  }

  .mt-5-minus {
    margin-top: -5px;
  }

  .simple-tab {
    color: #ffff;
    position: absolute;
    top: 17px;
  }

  button.nav-link {
    position: relative;
  }

  .prepopulated-tab-name {
    color: #ffff;
    text-decoration: line-through;
    position: absolute;
    top: 17px;
  }
  .nav-tabs .nav-link.prepopulated-tab {
    background: #646464;
  }

  .flex-between {
    display: flex;
    justify-content: space-between;
  }

  .fullwidth {
    width: 100%;
  }

  .exceeded-capsules {
    max-width: 149px;
    margin-left: 27px;
    margin-top: 26px;
    font-size: 14px;
  }
  .submit-container {
    display: flex;
    justify-content: end;
    align-items: center;
  }
  .submit-errors {
    margin-right: 10px;
    min-width: 220px;
    p {
      min-height: auto;
      margin-bottom: 0px;
    }
  }
  .disabled {
    cursor: not-allowed;
  }
`;
